(Drupal => {
  Drupal.behaviors.kafMobileTable = {
    attach: context => {
      function wrap(el, wrapper) {
        wrapper.classList.add('forumla-table-mobile');
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
      }

      const table = document.querySelector('.bakers-formula .node__content table');

      if (table) {
        wrap(table, document.createElement('div'));
      }
    },
  };
})(Drupal);
